const getNonFreeMonths = (monthlyCosts) => monthlyCosts.filter(({ amount }) => amount > 0)

export const getSetupCosts = (setupCosts) => (setupCosts > 0 ? `£${setupCosts.toFixed(2)}` : 'no')

export const getFirstNonFreeMonthPrice = (monthlyCosts) => {
  const nonFreeMonths = getNonFreeMonths(monthlyCosts)
  return nonFreeMonths[0].amount
}
